import React from 'react';
import { useSecurity } from '../../../helpers/SecurityHooks';
import { appendScriptsCallback } from '../../../helpers/Utils';

export function FinanceManagementTypePage(): React.ReactElement {
  const currentSecurity = useSecurity('Finance', 'ManagementType');
  React.useEffect(() => {
    if (currentSecurity.checkAccess()) {
      appendScriptsCallback(["Areas/Finance/Scripts/Resources/en/res.ManagementType.en.js",
        "Areas/Finance/Scripts/Resources/en/Types.en.js",
        "Areas/Finance/Scripts/Enums.js",
        "Areas/Finance/Scripts/ManagementType/Index.js"], "initFinanceManagementType", {});
    }
  }, []);
  return (
    <div className="container-fluid">
      <header className="complete-grid">
        <div id="gridFilter1">
          <div id="gridfilter-toolbar"></div>
        </div>
      </header>
      <section id="gridContainer"></section>
      <ul id="gridContainer-menu"></ul>
    </div>
  );
}
